import './SupportPage.scss';

export function SupportPage() {
  return (
    <main className="support-page">
      <div className="support-page__container">
        <header className="support-page__header">
          <h1 className="support-page__title">Support</h1>
          <p className="support-page__subtitle">
            Thanks for using our Chrome extension!
            <br />
            If you have questions, issues, or feedback — you're in the right place.
          </p>
        </header>

        <section className="support-page__section">
          <h2 className="support-page__section-title">Common Questions</h2>

          <div className="support-page__card">
            <h3 className="support-page__question">How do I share a request?</h3>
            <ol className="support-page__steps">
              <li>Open Chrome DevTools</li>
              <li>Go to the Network tab</li>
              <li>Right-click on any HTTP request</li>
              <li>Select <strong>Share</strong></li>
              <li>Choose <em>Share as text</em> or <em>Share as link</em></li>
            </ol>
          </div>

          <div className="support-page__card">
            <h3 className="support-page__question">What data is included in a shared request?</h3>
            <p className="support-page__text">
              Depending on your settings, a shared request may include:
            </p>
            <ul className="support-page__list">
              <li>Request URL and HTTP method</li>
              <li>Headers</li>
              <li>Request body</li>
              <li>Authorization headers <span className="support-page__badge">masked by default</span></li>
              <li>Response data <span className="support-page__badge support-page__badge--optional">optional</span></li>
            </ul>
            <p className="support-page__text support-page__text--highlight">
              You always stay in control of what gets shared.
            </p>
          </div>

          <div className="support-page__card">
            <h3 className="support-page__question">Is my data secure?</h3>
            <div className="support-page__security-grid">
              <div className="support-page__security-item">
                <span className="support-page__security-icon">&#x1f512;</span>
                <span>Sensitive data is masked by default</span>
              </div>
              <div className="support-page__security-item">
                <span className="support-page__security-icon">&#x23f3;</span>
                <span>Shared links can expire automatically</span>
              </div>
              <div className="support-page__security-item">
                <span className="support-page__security-icon">&#x1f6ab;</span>
                <span>No tracking or analytics on shared content</span>
              </div>
              <div className="support-page__security-item">
                <span className="support-page__security-icon">&#x2705;</span>
                <span>Data is never sold or used for advertising</span>
              </div>
            </div>
          </div>

          <div className="support-page__card">
            <h3 className="support-page__question">Can I replay or export requests?</h3>
            <p className="support-page__text">
              Advanced features such as <strong>export as curl</strong>, <strong>request replay</strong>,
              and <strong>persistent storage</strong> are available in the Pro version.
            </p>
          </div>
        </section>

        <section className="support-page__section">
          <h2 className="support-page__section-title">Troubleshooting</h2>

          <div className="support-page__card">
            <h3 className="support-page__question">The extension doesn't appear in DevTools</h3>
            <ul className="support-page__list">
              <li>Make sure the extension is enabled in <code>chrome://extensions</code></li>
              <li>Refresh the page and reopen DevTools</li>
              <li>Ensure you are on the Network tab</li>
            </ul>
          </div>

          <div className="support-page__card">
            <h3 className="support-page__question">I can't see some requests</h3>
            <ul className="support-page__list">
              <li>Requests must be triggered after DevTools is opened</li>
              <li>Some browser-internal requests are not accessible due to Chrome limitations</li>
            </ul>
          </div>
        </section>

        <section className="support-page__section">
          <h2 className="support-page__section-title">Feature Requests &amp; Feedback</h2>

          <div className="support-page__card">
            <p className="support-page__text">
              We actively improve the extension based on developer feedback. If you have:
            </p>
            <ul className="support-page__list support-page__list--inline">
              <li>Feature ideas</li>
              <li>UX improvements</li>
              <li>Bug reports</li>
            </ul>
            <p className="support-page__text">
              please reach out — we read everything.
            </p>
          </div>
        </section>

        <section className="support-page__section">
          <h2 className="support-page__section-title">Contact Support</h2>

          <div className="support-page__card support-page__card--contact">
            <div className="support-page__contact-item">
              <span className="support-page__contact-label">Email</span>
              <a href="mailto:support@shareq.site" className="support-page__contact-link">
                support@shareq.site
              </a>
            </div>
            <div className="support-page__contact-item">
              <span className="support-page__contact-label">Bug reports</span>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="support-page__contact-link"
              >
                GitHub Issues
              </a>
            </div>
            <p className="support-page__text support-page__text--muted">
              We usually respond within 24–48 hours.
            </p>
          </div>
        </section>

      </div>
    </main>
  );
}
